// extracted by mini-css-extract-plugin
export default {"brandPromo":"gH-z","carousel":"hH-z"};